import React from "react";
import { Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";
import {
  AppCta,
  PaymentSafetyLine,
  detectDeviceType,
} from "components/Public/PublicBlocks";
import {
  PLATFORM_FEE_PERCENT,
  PRO_PAYOUT_PERCENT,
} from "variables/publicContent";

// TODO(owner): add a real example follower price range once you have one,
// e.g. "Most pros charge $X-$Y a month." Leave null to hide the line.
const EXAMPLE_FOLLOWER_PRICE_RANGE = null;

export default function PricingPage() {
  const [deviceType, setDeviceType] = React.useState("Web");
  React.useEffect(() => {
    document.title = "Pricing - Bite Logr";
    setDeviceType(detectDeviceType());
  }, []);

  return (
    <>
      <AuthHeader title="Pricing" lead="" deviceType={false} />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="10">
            <Card className="border-0 text-center mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="text-uppercase ls-1 pt-3 mb-0">
                  You set the price. You keep {PRO_PAYOUT_PERCENT}%.
                </h2>
              </CardHeader>
              <CardBody className="px-lg-5">
                <p className="text-lead mt-0">
                  You set your subscription price. Your followers pay you. We
                  keep {PLATFORM_FEE_PERCENT}% - you keep {PRO_PAYOUT_PERCENT}%.
                </p>
                <p className="text-muted mb-0">
                  Founding Anglers pay zero platform fees for life.{" "}
                  <a href="/auth/foundingangler">See if you qualify</a>.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg="5">
            <Card className="mb-4" style={{ minHeight: "100%" }}>
              <CardHeader className="bg-transparent">
                <h2 className="h3 mb-0">For pros</h2>
              </CardHeader>
              <CardBody>
                <ul className="pl-3">
                  {/* TODO(owner): state what is free vs paid for pros. */}
                  <li>
                    Create subscription plans, each with your own monthly
                    price. We recommend three tiers.
                  </li>
                  <li>
                    Pick which catch details each plan shows: location, lure,
                    notes, photo, weather.
                  </li>
                  <li>
                    We keep {PLATFORM_FEE_PERCENT}% of each subscription. You
                    keep {PRO_PAYOUT_PERCENT}%.
                  </li>
                  <li>Payouts go out monthly by direct deposit.</li>
                </ul>
                <AppCta
                  deviceType={deviceType}
                  label={deviceType === "Web" ? "Start Earning" : "Get App"}
                />
              </CardBody>
            </Card>
          </Col>
          <Col lg="5">
            <Card className="mb-4" style={{ minHeight: "100%" }}>
              <CardHeader className="bg-transparent">
                <h2 className="h3 mb-0">For anglers following pros</h2>
              </CardHeader>
              <CardBody>
                <ul className="pl-3">
                  <li>Each pro sets their own monthly price per plan.</li>
                  {EXAMPLE_FOLLOWER_PRICE_RANGE && (
                    <li>{EXAMPLE_FOLLOWER_PRICE_RANGE}</li>
                  )}
                  <li>
                    Higher plans show more of the pro's catch details.
                  </li>
                  {/* TODO(owner): state what is free vs paid for anglers. */}
                  <li>Cancel anytime from your account.</li>
                </ul>
                <AppCta
                  deviceType={deviceType}
                  color="info"
                  label={
                    deviceType === "Web" ? "Follow local pros" : "Get App"
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center mt-4">
          <Col lg="10">
            <Card className="border-0 mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="h3 mb-0">Compared to what you do now</h2>
              </CardHeader>
              <CardBody>
                <p className="text-muted">
                  <strong>Private Facebook groups:</strong> you get whatever
                  gets posted, from whoever posts it. On Bite Logr you follow a
                  specific pro and see their actual catches with lure,
                  location, weather and time attached.
                </p>
                <p className="text-muted mb-0">
                  <strong>A guided trip:</strong> you learn one day on the water
                  with one guide. A Bite Logr subscription shows you a pro's
                  catches every time they go out, month after month.
                </p>
                <PaymentSafetyLine className="mt-4" />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
